import { saveAs } from 'file-saver'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

import { companyAPI } from '../../api/services/company'
import { getCurrentMonthBoundaries } from '../../utils/dates.ts'
import { generateJpkFaXml } from '../../utils/invoices/createJpkFaXml.ts'
import { printInvoicesToOnePdf } from '../../utils/invoices/createPDF.ts'
import invoicesSummary from '../../utils/invoices/invoicesSummary.ts'
import Button from '../common/Button/Button.tsx'
import Calendar from '../common/Calendar/Calendar.tsx'
import Loader from '../common/Loader/Loader.tsx'
import GoToReportPage from './GoToReportPage.tsx'

const EppSection = () => {
  const { firstDay, lastDay } = getCurrentMonthBoundaries()
  const [fromDate, setFromDate] = useState(firstDay)
  const [toDate, setToDate] = useState(lastDay)
  const [loading, setLoading] = useState(false)

  const handleDownloadJPKFA = async () => {
    setLoading(true)
    try {
      const companyResponse = await companyAPI.getCompany()
      const company = companyResponse.data[0]
      if (!company) throw new Error('Nie znaleziono danych firmy')

      const allInvoices = await invoicesSummary(fromDate, toDate)
      if (!allInvoices || allInvoices.length === 0)
        throw new Error('Nie znaleziono faktur w podanym zakresie dat')

      const jpkXml = generateJpkFaXml(allInvoices, company, fromDate, toDate)
      const blob = new Blob([jpkXml], { type: 'application/xml' })
      saveAs(blob, `JPK_FA_${fromDate}_${toDate}.xml`)
    } catch (error) {
      toast.error(error instanceof Error ? error.message : (error as string))
    } finally {
      setLoading(false)
    }
  }

  const handleDownloadPDFs = async () => {
    setLoading(true)
    try {
      const companyResponse = await companyAPI.getCompany()
      const company = companyResponse.data[0]
      if (!company) throw new Error('Nie znaleziono danych firmy')

      const allInvoices = await invoicesSummary(fromDate, toDate)
      if (!allInvoices || allInvoices.length === 0)
        throw new Error('Nie znaleziono faktur w podanym zakresie dat')

      await printInvoicesToOnePdf(
        allInvoices,
        `faktury_zbiorcze-${fromDate}-${toDate}.pdf`
      )
    } catch (error) {
      toast.error(error instanceof Error ? error.message : (error as string))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={'border border-gray-300 dark:border-gray-600 mb-2 p-4 '}>
      {loading && <Loader label={'Generowanie raportu...'} />}
      <div className="mb-6">
        <label htmlFor="od">Podaj zakres dat do raportu</label>
        <div className={'flex gap-2'}>
          <Calendar
            placeholder={'Od:'}
            defaultDate={fromDate}
            setDate={setFromDate}
            maxDate={lastDay}
          />
          <Calendar
            placeholder={'Do:'}
            defaultDate={toDate}
            setDate={setToDate}
            maxDate={lastDay}
          />
          <GoToReportPage fromDate={fromDate} toDate={toDate} />

          <Button
            variant="filled"
            size="medium"
            color="secondary"
            type="submit"
            onClick={() => handleDownloadPDFs()}
          >
            {'Pobierz faktury'}
          </Button>

          <Button
            variant="filled"
            size="medium"
            color="secondary"
            type="submit"
            onClick={() => handleDownloadJPKFA()}
          >
            {'Pobierz plik JPK FA'}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default EppSection
